import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const { isAuthenticated, token } = useSelector((state) => state.auth);

  // Ensure authentication is properly checked before rendering
  if (token === null || isAuthenticated === false) {
    return <Navigate to="/LoginPage" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
